import React from 'react'

// shared components
import Section from 'components/atoms/Section'
import SectionItem from 'components/atoms/SectionItem'

// local components
import Form from './Form'

const Preferences = props => {
  const { account } = props

  return (
    <Section title='Preferences'>
      <SectionItem>
        <Form account={account} />
      </SectionItem>
    </Section>
  )
}

export default Preferences
